import { Percent } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";

export default function BillingDiscounts() {
  const [, navigate] = useLocation();
  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Discounts</h1>
        <p className="text-sm text-muted-foreground">
          Standalone discount rules — promo codes, seasonal offers, referral credits. Distinct from the per-plan
          and per-period discount % already configurable on a plan.
        </p>
      </div>

      <div className="flex flex-col items-center justify-center gap-3 rounded-md border border-dashed bg-muted/30 p-12 text-center">
        <Percent className="h-10 w-10 text-muted-foreground/60" />
        <div className="space-y-1">
          <p className="text-sm font-medium">Discounts module is on the roadmap</p>
          <p className="text-xs text-muted-foreground max-w-md">
            Today you can set: plan-level <span className="font-medium">discountPct</span>,
            period overrides (Quarterly / Six-Month / Yearly each with own discount), and cross-plan discounts
            via <span className="font-medium">plan_secondary_access</span>. A standalone Promo Codes /
            Referral table lands in a future phase.
          </p>
        </div>
        <Button variant="outline" size="sm" onClick={() => navigate("/billing/plans")}>
          Configure Plan Discounts
        </Button>
      </div>
    </div>
  );
}
